import React from 'react';
import { NextPage } from 'next';
import { NskHead } from '~/components/common/head/NskHead';
import { Page as Component } from '~/components/specifics/vendors/deals/[id]/deal_estimation_headers/[headerId]/Page';

export const PATH = (id: number, headerId: number): string =>
  `/vendors/deals/${id}/deal_estimation_headers/${headerId}`;

const DealEstimationHeaders: NextPage = () => (
  <>
    <NskHead title="見積り履歴確認" />
    <Component />
  </>
);

export default DealEstimationHeaders;
